// extracted by mini-css-extract-plugin
export default {"container":"CyberSportCategories_container--lRU"};